import { BehaviorSubject, Subject } from 'rxjs';
import Material from 'src/app/model/material/material';
import WindowStickerSize from 'src/app/model/product/windowsticker/windowsticker-size';
import { HeightWidthTuple } from 'src/app/model/util-classes/height-width-tuple';
import { WindowStickerSizeMaterialsForFormatControllerRequestService } from '../service/window-sticker-size-materials-for-format-controller-request.service';
import { WindowStickerSizeMaterialsForFormatResult } from '../service/window-sticker-size-materials-for-format-result';
import { WindowStickerSizeSelectionList } from '../service/window-sticker-size-selection-list';
import { WindowStickerSizeSelectionListControllerRequestService } from '../service/window-sticker-size-selection-list-controller.service';
import { WindowStickerSizeSingleSizeControllerRequestService } from '../service/window-sticker-size-single-size-controller-request.service';

export class WindowStickerSizeGetter {
  private selectionListSubject: BehaviorSubject<
    WindowStickerSizeSelectionList | {}
  > = new BehaviorSubject({});

  private materialChanged: Subject<any> = new Subject();

  private formatsChanged: Subject<any> = new Subject();

  constructor(
    private windowStickerSizeSelectionListControllerRequestService: WindowStickerSizeSelectionListControllerRequestService,
    private windowStickerSizeMaterialsForFormatControllerRequestService: WindowStickerSizeMaterialsForFormatControllerRequestService,
    private windowStickerSizeSingleSizeControllerRequestService: WindowStickerSizeSingleSizeControllerRequestService
  ) {}

  public getSelectionListSubject(): Subject<
    WindowStickerSizeSelectionList | {}
  > {
    return this.selectionListSubject;
  }

  public getMaterialChangedSubject(): Subject<any> {
    return this.materialChanged;
  }

  public getFormatsChangedSubject(): Subject<any> {
    return this.formatsChanged;
  }

  public async fetchSelectionList(): Promise<void> {
    const selectionList =
      await this.windowStickerSizeSelectionListControllerRequestService.getSelectionList();
    this.selectionListSubject.next(selectionList);
  }

  public fetchMaterialsForFormats(
    heightWidthTuples: HeightWidthTuple[]
  ): Promise<WindowStickerSizeMaterialsForFormatResult> {
    return this.windowStickerSizeMaterialsForFormatControllerRequestService.getMaterialsForFormats(
      heightWidthTuples
    );
  }

  public fetchWindowStickerSingleSize(
    material: Material,
    height: number,
    width: number
  ): Promise<WindowStickerSize> {
    return this.windowStickerSizeSingleSizeControllerRequestService.getSingleSizeForMaterial(
      material.ordinal,
      height,
      width
    );
  }

  destroy(): void {
    if (this.selectionListSubject != null) {
      this.selectionListSubject.complete();
    }
    if (this.materialChanged != null) {
      this.materialChanged.complete();
    }
    if (this.formatsChanged != null) {
      this.formatsChanged.complete();
    }
  }
}
